import { setAuthorization } from '../helpers/api/apiCore';
import { authApiResponseSuccess } from '../redux/actions';
import { AuthActionTypes } from '../redux/auth/constants';

export const handleUserLogin = (dispatch, api, user) => {
    // Set the logged-in user
    api.setLoggedInUser(user);

    // Set authorization token
    setAuthorization(user['token']);

    // Dispatch the success action for the login
    dispatch(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
};

export const sizePerPageList = [
    {
        text: '5',
        value: 5,
    },
    {
        text: '10',
        value: 10,
    },
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
];

export const masterColumns = (t) => [
    { Header: t('Device ID'), accessor: 'device_id', sort: true },
    { Header: t('Asset Type Name'), accessor: 'asset_type_name', sort: true },
    { Header: t('Asset Type Code'), accessor: 'asset_type_code', sort: true },
    { Header: t('Asset Type Id'), accessor: 'asset_type_id', sort: true },
    { Header: t('Asset Number Code'), accessor: 'asset_number_code', sort: true },
    { Header: t('Asset Number ID'), accessor: 'asset_number_id', sort: true },

    { Header: t('SMMS Code'), accessor: 'smms_asset_code', sort: true },
    { Header: t('SMMS Name'), accessor: 'smms_asset_name', sort: true },

    { Header: t('Vendor Name'), accessor: 'vendor_name', sort: true },
    { Header: t('Channel'), accessor: 'channel', sort: false },
    { Header: t('Type'), accessor: 'type', sort: true },
];

export const addStationColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate',
        sort: true,
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName',
        sort: true,
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode',
        sort: true,
    },
    {
        Header: t('Division Name'),
        accessor: 'divisionName',
        sort: true,
    },
    {
        Header: t('Division Code'),
        accessor: 'divisionCode',
        sort: true,
    },
    {
        Header: t('Station Name'),
        accessor: 'stationName',
        sort: true,
    },
    {
        Header: t('Station Code'),
        accessor: 'stationCode',
        sort: true,
    },
    {
        Header: t('Station Master Name'),
        accessor: 'stationMasterName',
        sort: false,
    },
    {
        Header: t('City'),
        accessor: 'city',
        sort: false,
    },
    {
        Header: t('State'),
        accessor: 'state',
        sort: false,
    },
    {
        Header: t('Hardware'),
        accessor: 'hardware',
        sort: false,
    },
    {
        Header: t('Software'),
        accessor: 'software',
        sort: false,
    },
    {
        Header: t('Action'),
        accessor: 'action',
        sort: false,
    },
];
export const addZoneColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate', // FIXED
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName', // FIXED
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode', // FIXED
    },
    {
        Header: t('Zone ID'),
        accessor: 'zoneId', // FIXED
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];

export const addDivisionColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdDate',
        sort: true,
    },
    {
        Header: t('Zone ID'),
        accessor: 'zoneId',
        sort: true,
    },
    {
        Header: t('Zone Code'),
        accessor: 'zoneCode',
        sort: true,
    },
    {
        Header: t('Zone Name'),
        accessor: 'zoneName',
        sort: true,
    },
    {
        Header: t('Division Name'),
        accessor: 'divisionName',
        sort: true,
    },
    {
        Header: t('Division Code'),
        accessor: 'divisionCode',
        sort: true,
    },
    {
        Header: t('Division ID'),
        accessor: 'divisionId',
        sort: true,
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];
export const addVendorColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdAt',
    },
    {
        Header: t('Cloud Code'),
        accessor: 'vendor_cloud_code',
    },
    {
        Header: t('Cloud Name'),
        accessor: 'vendor_cloud_name',
    },
    {
        Header: t('Gateway Code'),
        accessor: 'vendor_gw_code',
    },
    {
        Header: t('Gateway Name'),
        accessor: 'vendor_gw_name',
    },
    {
        Header: t('Email'),
        accessor: 'email',
    },
    {
        Header: t('Station'),
        accessor: 'stationName',
    },

    {
        Header: t('Action'),
        accessor: 'action',
    },
];
export const addUserColumns = (t) => [
    {
        Header: t('Created Date'),
        accessor: 'createdAt',
    },
    {
        Header: t('Name'),
        accessor: 'name',
    },
    {
        Header: t('Email'),
        accessor: 'email',
    },
    {
        Header: t('Role'),
        accessor: 'role',
    },
    {
        Header: t('Location'),
        accessor: 'location',
    },
    {
        Header: t('User ID'),
        accessor: 'userId',
    },
    {
        Header: t('Action'),
        accessor: 'action',
    },
];

export const addEquipmentColumns = (t, equipmentType, equipmentConfig) => {
    const config = equipmentConfig[equipmentType];

    return [
        { Header: t('Created Date'), accessor: 'createdDate', sort: true },
        {
            Header: t(config.extraField.label),
            accessor: config.extraField.name,
            sort: true,
        },
        { Header: t('Parameter Type Id'), accessor: 'parameterTypeId', sort: true },
        { Header: t('Type Code'), accessor: 'assetTypeCode', sort: true },
        { Header: t('Number Code'), accessor: 'assetNumberCode', sort: true },
        { Header: t('SMMS Code'), accessor: 'smmsAssetCode', sort: true },
        { Header: t('SMMS Name'), accessor: 'smmsAssetName', sort: true },
        { Header: t('Device ID'), accessor: 'device', sort: true },
        { Header: t('Internal ID'), accessor: 'internalId', sort: true },
        { Header: t('Channel'), accessor: 'channel', sort: false },
        { Header: t('Type'), accessor: 'type', sort: true },
        { Header: t('Station Master Name'), accessor: 'stationMasterName', sort: false },
        { Header: t('Station'), accessor: 'stationName', sort: false },
        { Header: t('Vendor'), accessor: 'vendor', sort: true },
        { Header: t('City'), accessor: 'city', sort: false },
        { Header: t('State'), accessor: 'state', sort: false },
        { Header: t('Alert'), accessor: 'stopAlert', sort: false },
        { Header: t('Action'), accessor: 'action', sort: false },
    ];
};

export const versionHistoryColumns = () => [
    {
        Header: 'Time Stamp',
        accessor: 'date',
        sort: true,
    },
    {
        Header: 'Module',
        accessor: 'module',
        sort: true,
    },
    {
        Header: 'Version',
        accessor: 'version',
        sort: false,
    },
    {
        Header: () => <div style={{ textAlign: 'left' }}>Enhancements & Fixes</div>,
        headerStyle: { textAlign: 'left' },
        accessor: 'changes',
        sort: false,
        style: { textAlign: 'left' },
        Cell: ({ value }) => (
            <div style={{ textAlign: 'left' }}>
                {value.map((change, index) => (
                    <div key={index}>
                        {index + 1}. {change}
                    </div>
                ))}
            </div>
        ),
    },
];
